let current = null;
const listeners = new Set();
const emit = () => listeners.forEach(listener => listener());
export const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const getChallenge = () => current;
export const finishChallenge = (token, result, error) => {
  if (!current || current.challengeToken !== token) return;
  const pending = current;
  current = null;
  window.clearTimeout(pending.timer);
  emit();
  if (error) pending.reject(error); else pending.resolve(result);
};
export const requestTwoFactor = data => {
  if (current) return Promise.reject(new Error('A sign-in verification is already open. Please finish it first.'));
  if (!data?.challengeToken) return Promise.reject(new Error('Invalid sign-in verification request.'));
  return new Promise((resolve, reject) => {
    const token = data.challengeToken;
    current = { ...data, resolve, reject,
      timer: window.setTimeout(() => finishChallenge(token, null, new Error('Verification expired. Please sign in again.')), 300000) };
    emit();
  });
};
